var map = {
	"./gallery-wip-t-tracks_00.jpg": 2987,
	"./gallery-wip-t-tracks_01.jpg": 2988,
	"./gallery_00.jpg": 2989,
	"./gallery_01.jpg": 2990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2986;